import React from "react";
import BontonQrMappingList from "./BontonQrMappingList";

const MappedList = () => (
    <BontonQrMappingList status={1} title="Mapped List" />
);

export default MappedList;
